import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { getDefaultRouteForRole } from '../config/role-routes';
import { type EmployeeRole, EMPLOYEE_ROLES } from '../types/employee.types';

/** Set of valid EmployeeRole values for O(1) runtime validation */
const VALID_ROLES = new Set<string>(EMPLOYEE_ROLES);

/**
 * 403 Unauthorized page component.
 * Displayed when a user attempts to access a route they do not have permission for.
 */
export function UnauthorizedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  const handleGoHome = () => {
    // Validate role before using, fallback to login if invalid
    if (user?.role && VALID_ROLES.has(user.role)) {
      const defaultRoute = getDefaultRouteForRole(user.role as EmployeeRole);
      navigate(defaultRoute, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  };

  return (
    <Result
      status="403"
      title={t('errors:auth.forbiddenTitle')}
      subTitle={t('errors:auth.forbiddenSubTitle')}
      extra={
        <Button type="primary" onClick={handleGoHome}>
          {t('errors:auth.goHome')}
        </Button>
      }
    />
  );
}
